import {
  BookCostCoverageType,
  GradeType,
  HowDidYouFindUsType,
  JobRoleType,
  ProgramTypeEnum,
} from './teacher.interface';

export { ProgramTypeEnum };

export enum UserOnboardingStepEnum {
  Video = 'video',
  SchoolInfo = 'school_info',
  ClassInfo = 'class_info',
  HowDidYouFindUs = 'how_did_you_find_us',
}

export interface UserOnboardingVideoData {
  videoWatchTimeSeconds: number;
  videoUrl?: string;
}

export interface UserOnboardingSchoolInfoData {
  state: string;
  schoolName?: string;
  city?: string;
  grades?: GradeType[];
  customGrade?: string;
}

export interface UserOnboardingClassInfoData {
  jobRole?: JobRoleType;
  studentCount: number;
  programType: ProgramTypeEnum;
  mobileNumber?: string;
  grades?: GradeType[];
  customGrade?: string;
}

export interface UserOnboardingHowDidYouFindUsData {
  howFoundUs?: HowDidYouFindUsType;
  howFoundUsOther?: string;
  referralCode?: string;
  bookCostCoverage?: BookCostCoverageType;
}

export interface UserOnboardingModel {
  // Video step
  videoWatchTimeSeconds?: number;
  videoUrl?: string;

  // School info step
  country?: string;
  state?: string;
  city?: string;
  schoolName?: string;
  grades?: GradeType[];
  customGrade?: string;

  // Class info step
  jobRole?: JobRoleType;
  studentCount?: number;
  programType?: ProgramTypeEnum;
  mobileNumber?: string;

  // How did you find us step
  howFoundUs?: HowDidYouFindUsType;
  howFoundUsOther?: string;
  referralCode?: string;
  bookCostCoverage?: BookCostCoverageType;

  // Step tracking
  completedSteps?: UserOnboardingStepEnum[];
  currentStep?: UserOnboardingStepEnum;
  startedAt?: Date | string;
  completedAt?: Date | string;
}

export interface SaveUserOnboardingStepPayload {
  step: UserOnboardingStepEnum;
  data:
    | UserOnboardingVideoData
    | UserOnboardingSchoolInfoData
    | UserOnboardingClassInfoData
    | UserOnboardingHowDidYouFindUsData;
}
